import Typography from "@shared/v2/Typography";
import AiProvider from "@shared/AiAssistant/AiProvider";
import { lazyAiComponent } from "@shared/AiAssistant/lazyAiComponent";

const AiSettings = lazyAiComponent("AiSettings");
import { useFeatureFlags } from "../reducers/layoutReducer/selectors";

const GabbiAiSettings = () => {
  const featureFlags = useFeatureFlags() as { lenderReferral: boolean };
  return (
    <AiProvider>
      <div className="tw-mx-auto tw-p-[16px] tw-max-w-[1500px] tw-flex tw-flex-col tw-gap-[16px]">
        <div className="tw-bg-white tw-rounded-[8px] tw-border-[1px] tw-border-solid tw-border-gray-10 tw-p-[32px] tw-flex tw-flex-col tw-gap-[24px]">
          {/* @ts-expect-error until v2 components are TS */}
          <Typography variant="headline1">Gabbi AI</Typography>
          <AiSettings envoy_enabled={featureFlags.lenderReferral} />
        </div>
      </div>
    </AiProvider>
  );
};

export default GabbiAiSettings;
